import React, { useState, useEffect, useRef } from "react";
import { ChatMessageList } from "@/components/ui/chat/chat-message-list";
import { ChatBubble, ChatBubbleAvatar, ChatBubbleMessage } from "@/components/ui/chat/chat-bubble";
import { ChatInput } from "@/components/ui/chat/chat-input";
import { Button } from "../ui/button";
import { CornerDownLeft } from "lucide-react";
import UserType from "./messagetype/userMessage";
import ReplyMessage from "./messagetype/repliesMessaage";
import ThredMessage from "./messagetype/threadMessage";
import StepsMessage from "./messagetype/stepMessage";
import { chatBaseURL, chatWebSocketURL } from "@/store/constant";

interface Message {
    text: string;
    timestamp: string;
    messagesFrom: string;
}

export default function AgentChat() {
    const [messages, setMessages] = useState<Message[]>([
        {
            text: "hi",
            timestamp: "2024-10-25 12:24:00",
            messagesFrom: 'thread'
        },
        {
            text: "Hello! How can I assist you today?",
            timestamp: "2024-10-25 11:00:00",
            messagesFrom: 'user'
        },
        {
            text: "Hello! How can I assist you today?",
            timestamp: "2024-10-25 11:00:00",
            messagesFrom: 'agent-steps'
        }
    ]);
    const [inputValue, setInputValue] = useState("");
    const [currentWebSocket, setCurrentWebSocket] = useState<WebSocket | null>(null);
    const initRef = useRef(false);
    
    
    useEffect(() => {
        if (initRef.current) return;
        initRef.current = true;
        
        const fetchMessages = async () => {
            const res = await fetch(`${chatBaseURL}/chat/messages`);
            const fetchedMessages:Message[] = await res.json();
            setMessages(fetchedMessages);
        };

        fetchMessages();
        join();

        return () => {
            if (currentWebSocket) {
                currentWebSocket.close();
            }
        };
    }, []);

    const join = () => {
        const ws = new WebSocket(chatWebSocketURL);
        let rejoined = false;
        const startTime = Date.now();

        ws.addEventListener("open", () => {
            setCurrentWebSocket(ws);
        });

        ws.addEventListener("message", (event) => {
            const newMessage = JSON.parse(event.data);
            setMessages((prevMessages) => [...prevMessages, newMessage]);
        });

        ws.addEventListener("close", () => {
            console.log("WebSocket closed, reconnecting");
            rejoin();
        });

        ws.addEventListener("error", () => {
            console.log("WebSocket error, reconnecting");
            rejoin();
        });

        const rejoin = async () => {
            if (!rejoined) {
                rejoined = true;
                setCurrentWebSocket(null);

                const timeSinceLastJoin = Date.now() - startTime;
                if (timeSinceLastJoin < 5000) {
                    await new Promise((resolve) => setTimeout(resolve, 5000 - timeSinceLastJoin));
                }

                join();
            }
        };
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log("Called handle Submit");
        if (inputValue.trim() && currentWebSocket) {
            const now = new Date().toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            });
            const message = { text: inputValue, messagesFrom: "user", timestamp: now };
            currentWebSocket.send(JSON.stringify(message));
            setMessages((prevMessages) => [...prevMessages, message]);
            setInputValue("");
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            console.log("Called Handle Key Down");
            handleSubmit(e);
        }
    };

    return (
        <div className="flex flex-col bg-white h-full">
            <ChatMessageList className="gap-0">
                {messages.map((message, index) => (
                    <ChatBubble key={index} className="w-full max-w-full">
                         {/* <ChatBubbleAvatar />  */}
                        {/* <ChatBubbleMessage> */}
                        {
                            message.messagesFrom === 'user' 
                                ? <UserType message={message} /> 
                                : message.messagesFrom === 'agents' ? 
                                 <ReplyMessage message={message} />
                                : message.messagesFrom === 'agent-steps' ?
                                    <StepsMessage message={message} />
                                 : <ThredMessage message={message} />
                        }
                        {/* </ChatBubbleMessage> */}
                    </ChatBubble>
                ))}
            </ChatMessageList>
            <form onSubmit={handleSubmit} className="p-4 flex items-center gap-2">
                <ChatInput
                    placeholder="Type your message here..."
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="mb-2"
                />
                <Button type="submit" size="sm" className="gap-1.5">
                    <CornerDownLeft className="size-3.5" />
                </Button>
            </form>
        </div>
    );
}